export const AccountContentNegativeKeywordList = {
  parent: 'Account',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Account Content Negative Keyword List',
    },
    Id: {
      'bulk-upload-header': 'Id',
    },
    ParentId: {
      'bulk-upload-header': 'Parent Id',
    },
    ClientId: {
      'bulk-upload-header': 'Client Id',
    },
    Name: {
      'bulk-upload-header': 'Name',
    },
  },
};
